import { TagsDetails } from "@/models/tags";
import { tagsService } from "@/services/tags.services";
import { defineStore } from "pinia";
import { computed, ComputedRef, ref } from "vue";

export interface ExtraModulesState {
  currentRouteParam: object;
  tagsList: TagsDetails[];
  pageScrollFlag: boolean;
}

export const useExtraStore = defineStore("extra", () => {
  // STATES
  const currentRouteParam = ref<ExtraModulesState["currentRouteParam"]>({});
  const tagsList = ref<ExtraModulesState["tagsList"]>([]);
  const pageScrollFlag = ref<ExtraModulesState["pageScrollFlag"]>(false);

  // ACTIONS
  const setCurrentRoute = (value: ExtraModulesState["currentRouteParam"]) => {
    currentRouteParam.value = value;
  };
  const fetchTags = async () => {
    const result = await tagsService.getAllTags();
    tagsList.value = result.data.content;
  };
  const setPageScrollFlag = (value: ExtraModulesState["pageScrollFlag"]) => {
    pageScrollFlag.value = value;
  };

  // GETTERS
  const getTags: ComputedRef<TagsDetails[]> = computed(() => tagsList.value);
  const getPageScrollFlag: ComputedRef<boolean> = computed(
    () => pageScrollFlag.value,
  );
  const getCurrentRouteParams = computed(() => currentRouteParam.value);

  return {
    getTags,
    getPageScrollFlag,
    getCurrentRouteParams,
    setCurrentRoute,
    fetchTags,
    setPageScrollFlag,
  };
});
